const initialState = {
  treeData: [],
  childrenMap: {},
  loading: false,
  error: null,
};

export default initialState;
